import { useQuery } from "@tanstack/react-query";
import { fetchRailway } from "@/lib/apiClient";

// Re-export fetchRailway helper through apiClient if needed, or call directly
async function checkAdmin(): Promise<boolean> {
  try {
    const res = await fetchRailway<{ isAdmin: boolean }>("/v1/admin/check");
    if ("error" in res) return false;
    return res.data?.isAdmin ?? false;
  } catch {
    return false;
  }
}

export function useAdmin() {
  const { data: isAdmin = false, isLoading } = useQuery({
    queryKey: ["admin-check"],
    queryFn: checkAdmin,
    staleTime: 5 * 60_000, // 5 min — no need to refetch often
    retry: false,
  });

  return { isAdmin, isLoading };
}
